const apiError = {
    transfers: {
        "1001": "EXP_GAMEDY_LOCKED",
        "-999": "EXP_INVALID_TRANSFER_DML",
        "7": "EXP_INVALID_GAMEDAY_PLAYER_CO",
        "8": "EXP_INVALID_MATCHDAY_PLAYER_C",
        "12": "EXP_TEAM_VALUE_EXCEDED",
        "13": "EXP_GAMEDAY_COMPOSITION_NOT",
        "24": "EXP_MATCHDAY_COMPOSITION_NOT",
        "15": "EXP_CAPTAIN_NOT_EXISTS",
        "16": "EXP_EXCEEDED_LIMIT_PLAYERS_PER_TEAM",
        "9": "EXP_DUPLICATE_PLAYERID_FOUND",
        "22": "EXP_PLAYER_INOUT_COUNT_NOT_M",
        "23": "EXP_TEAM_BALANCE_NEGATIVE",
        "26": "EXP_INVALID_BENCHPLAYER_COUN",
        "5": "EXP_GAMEDAY_NOT_CURRENT",
        "28": "EXP_TEAM_NOT_EXISTS",
        "0": "EXP_SOME_ERROR_OCCURED_3",
        "0": "EXP_SOME_ERROR_OCCURED_2",
        "-1": "DB_ERROR",
        "9999": "AUTH_ERROR"
    },

    subs: {
        "1001": "",
        "1001": "EXP_GAMEDY_LOCKED",
        "2": "EXP_INVALID_SUBSTITUTION",
        "7": "EXP_INVALID_GAMEDAY_PLAYER_COUNT",
        "8": "EXP_INVALID_MATCHDAY_PLAYER_COUNT",
        "12": "EXP_TEAM_VALUE_EXCEDED",
        "13": "EXP_GAMEDAY_COMPOSITION_NOT_MATCH",
        "24": "EXP_MATCHDAY_COMPOSITION_NOT_MATCH",
        "15": "EXP_CAPTAIN_NOT_EXISTS",
        "16": "EXP_EXCEEDED_LIMIT_PLAYERS_PER_TEAM",
        "9": "EXP_DUPLICATE_PLAYERID_FOUND",
        "23": "EXP_TEAM_BALANCE_NEGATIVE",
        "26": "EXP_INVALID_BENCHPLAYER_COUNT",
        "0": "EXP_SOME_ERROR_OCCURED_2",
        "-1": " DB ERROR",
        "28": "EXP_TEAM_NOT_EXISTS",
        "9999": "AUTH_ERROR"
    },



    captainChange: {
        "1001": "EXP_GAMEDY_LOCKED",
        "-999": "EXP_INVALID_CAPTAIN",
        "502": "EXP_INVALID_IS_BOOSTER_1_TEAM_VALUE",
        "7": "EXP_INVALID_GAMEDAY_PLAYER_COUNT",
        "8": "EXP_INVALID_MATCHDAY_PLAYER_COUNT",
        "12": "EXP_TEAM_VALUE_EXCEDED",
        "13": "EXP_GAMEDAY_COMPOSITION_NOT_MATCH",
        "24": "EXP_MATCHDAY_COMPOSITION_NOT_MATCH",
        "15": "EXP_CAPTAIN_NOT_EXISTS",
        "16": "EXP_EXCEEDED_LIMIT_PLAYERS_PER_TEAM",
        "9": "EXP_DUPLICATE_PLAYERID_FOUND",
        "23": "EXP_TEAM_BALANCE_NEGATIVE",
        "26": "EXP_INVALID_BENCHPLAYER_COUNT",
        "0": "EXP_SOME_ERROR_OCCURED_2",
        "28": "EXP_TEAM_NOT_EXISTS",
        "9999": "AUTH_ERROR"
    },

    createTeam: {
        "1001": "EXP_GAMEDY_LOCKED",
        "103": "EXP_TEAM_ALREADY_CREATED",
        "7": "EXP_IVALID_GAMEDAY_PLAYER_COUNT",
        "8": "EXP_IVALID_MATCHDAY_PLAYER_COUNT",
        "9": "EXP_DUPLICATE_PLAYERID_FOUND",
        "12": "EXP_TEAM_VALUE_EXCEEDED",
        "13": "EXP_INVALID_GAMEDAY_COMPOSITION",
        "24": "EXP_INVALID_MATCHDAY_COMPOSITION",
        "14": "EXP_INVALID_BENCH_PLAYER_COUNT",
        "15": "EXP_CAPTAIN_DOES_NOT_EXISTS",
        "16": "EXP_EXCEEDED_LIMT_PLAYERS_PER_TEAM",
        "-1": "DB_ERROR",
        "2001": "EXP_USER_NOT_FOUND",
        "9999": "AUTH_ERROR"
    },

    createLeague: {
        '1': 'SUCCESS',
        '3': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '4': 'EXP_LEAGUE_NAME_NULL',
        '5': 'EXP_LEAGUE_NAME_EXISTS',
        '11': 'EXP_TOUR_IS_END',
        '-1': 'DB_ERROR',
    },

    joinLeague: {
        '1': 'LEAGUE_JOIN_SUCCESS',
        '6': 'EXP_LEAGUE_DELETED',
        '7': 'EXP_INVALID_LEAGUE_CODE',
        '9': 'EXP_USER_ALREADY_MEMBER',
        '10': 'EXP_USER_ADMIN_LOCKED',
        '8': 'EXP_LEAGUE_MEMBER_EXCEEDED',
        '99': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '0': 'DB_ERROR',
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },

    reActivate: {
        '1': 'LEAGUE_REACTIVATE_SUCCESS',
        '5': 'EXP_LEAGUE_ALREADY_RELAUNCH',
        '3': 'EXP_LEAGUE_COUNT_EXCEEDED',
        '4': 'EXP_LEAGUE_NAME_NULL',
        '99': 'EXP_LEAGUE_JOIN_EXCEEDED',
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },

    reJoin: {
        '1': 'reJoinInfo',
        '2': 'REJOIN_REQUEST_SEND_TO_ADMIN_OWNER',
        '3': 'EXP_LEAGUE_DELETED',//'EXP_LEAGUE_JOIN_EXCEEDED',
        '99': 'EXP_LEAGUE_JOIN_EXCEEDED',//'DB_ERROR',
        '-1': 'DB_ERROR',//'REJOIN_REQUEST_SEND_TO_ADMIN_OWNER',
        //'2' : 'MEMBER_DIRECTLY_PART_OF_THE_LEAGUE',
        "9999": "AUTH_ERROR"
    },

    deletePreviousLeague: {
        '1': 'deletePreviousLeague_SUCCESS',
        '5': 'EXP_LEAGUE_ALREADY_DELETED',
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },

    deletePreviousMembersLeague: {
        '1': 'deletePreviousMembersLeague_SUCCESS',
        '5': 'EXP_MEMBER_ALREADY_DELETED_LEAGUE',
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },
    leaveLeague: {
        '1': "SUCCESS_LEAVE_LEAGUE",
        '-1': "FAILED_LEAVE_LEAGUE",
        "9999": "AUTH_ERROR"
    },
    suspension: {
        '1': "SUCCESS_SUSPENSION",
        '11': "EXP_INVALID_LEAGUE_OWNER",
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },
    unsuspension: {
        '1': "SUCCESS_UNSUSPENSION",
        '11': "EXP_INVALID_LEAGUE_OWNER",
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },
    deleteLeague: {
        '1': "SUCCESS_DELETE_LEAGUE",
        '2': "FAILED_DELETE_LEAGUE",
        '-1': 'DB_ERROR',
        "9999": "AUTH_ERROR"
    },
    updateLeagueName: {
        '1': "SUCCESS_UPDATE_LEAGUE_NAME",
        '2': "FAILED_UPDATE_LEAGUE_NAME",
        '4': "EXP_LEAGUE_NAME_NULL",
        '11': 'FAILED_UPDATE_LEAGUE_NAME',
        '-1': 'DB_ERROR',
        '-555': "EXP_LEAGUE_NAME_NULL",
        "9999": "AUTH_ERROR"
    },
    teamName: {
        '-555': 'INVALID_TEAM_NAME',
        "9999": "AUTH_ERROR"
    },

    teamNameUpdate: {
        '1': 'TEAMNAMEUPDATESUCESS',
        '-555': 'INVALID_TEAM_NAME',
        "9999": "AUTH_ERROR"
    }
}

export default apiError